import { Security } from './security.dto'

export const makeGoogleTicker = (
  security: Pick<Security, 'googleExchangeCode' | 'ticker'>,
) => `${security.googleExchangeCode}:${security.ticker}`

export const makeSecurityLink = (
  security: Pick<Security, 'name' | 'googleExchangeCode' | 'ticker'>,
  prefix: boolean = true,
) => {
  return `${prefix ? '/share-prices/' : '/'}${convertToKebabCase(
    security.name,
  )}-${makeGoogleTicker(security)}`
}

export function makeSecurityDescription({
  name,
  ticker,
  ratios,
}: Security): string {
  const styleSuggestion = `${ticker} is currently rated as a ${ratios?.general?.style} `

  return `Discover all the factors affecting ${name}'s share price. ${
    ratios ? styleSuggestion : ''
  }| Stockopedia`
}

export function convertToKebabCase(text: string): string {
  return text
    .replace(/([a-z])([A-Z])/g, '$1-$2')
    .replace(/\&/g, '')
    .replace(/\s+/g, '-')
    .replace(/\'/g, '-')
    .replace(/\(/g, '')
    .replace(/\)/g, '')
    .replace(/\./g, '%2E')
    .toLowerCase()
}

export const makeUnlockLink = () => `/auth/register/`

export function getChangeClass(change: number): string {
  let className = ''

  if (0 < change) {
    className = 'stk-text-success'
  } else if (change < 0) {
    className = 'stk-text-danger'
  }

  return className
}

export const capitalise = (str: string) =>
  str.length > 1 ? str[0].toLocaleUpperCase() + str.substr(1) : str

export const possessive = (str: string) =>
  str.toLowerCase().endsWith('s') ? `${str}'` : `${str}'s`
